import $axios from "@/plugins/axios";
const task = {
    //查首页banner
    //getInfo: params => $axios.post3('PC/QuestionTask/GetInfo', params),
    getPackageInfo: params => $axios.post3('PC/QuestionTask/GetPackageInfo', params),
    getPackageDetails: params => $axios.post3('PC/QuestionTask/GetPackageDetails', params),
    submitAnswer: params => $axios.post('PC/QuestionTask/SubmitAnswer', params),
    finishTask: params => $axios.post3('PC/QuestionTask/FinishTask', params),

    //banners: params => $axios.get(`/Home/banners`, params),

}
export default task;